import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route } from 'react-router-dom';
import Header from './common/Header';
import Footer from './common/Footer';
import HomePage from './homePage/HomePage';
import ErrorPage from './ErrorPage';
import NotFoundPage from './NotFoundPage';
import { Helmet } from "react-helmet";

class App extends React.Component {
    render() {
        return (
            <div>
                <Helmet>
                    <title>Ailsa Lyn Artist</title>
                    <meta property="og:title" content="Matthew Dove" />
                    <meta property="og:description" content="Matthew Dove - Cyclist, developer, adventurer" />
                    <meta property="og:image" content="https://placehold.it/100" />
                </Helmet>
                <Header />
                <Switch>
                    <Route exact path="/" component={HomePage} />
                    <Route path="/error" component={ErrorPage} />
                    <Route component={NotFoundPage} />
                </Switch>
                <Footer />
            </div>
        );
    }
}
App.propTypes = {
    children: PropTypes.element
};

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js